import { useEffect } from 'react';
import { useAuth } from './AuthModule';
import { API } from './partials/profileHelpers';
import { useI18n } from '../i18n/I18nModule';
import { isUiLocale } from '../i18n/uiLanguages';

/** When logged in, apply saved uiLocale from user_settings. */
export default function LocaleSyncFromSettings() {
  const { user } = useAuth();
  const { setLocale } = useI18n();
  const userId = user?.id;

  useEffect(() => {
    if (!userId) return;
    let cancelled = false;
    fetch(`${API}/api/users/${encodeURIComponent(userId)}/settings`)
      .then((res) => (res.ok ? res.json() : null))
      .then((settings) => {
        if (cancelled || !settings) return;
        const code = settings.uiLocale ?? settings.ui_locale;
        if (isUiLocale(code)) setLocale(code);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [userId, setLocale]);

  return null;
}
